/**
 * Configuration du navigateur d'images
 * Vous pouvez modifier ce fichier pour personnaliser les images disponibles
 */

// Configuration par défaut avec des images de placeholder
const defaultImageConfig = {
    // Images d'exemple avec des placeholders colorés
    predefinedImages: [
        {
            src: 'https://placehold.co/300x200/FF0000/FFFFFF?text=Image+Rouge',
            title: 'Image Rouge',
            alt: 'Image de démonstration rouge',
            width: 300,
            height: 200,
            category: 'demo'
        },
        {
            src: 'https://placehold.co/300x200/00FF00/FFFFFF?text=Image+Verte',
            title: 'Image Verte',
            alt: 'Image de démonstration verte',
            width: 300,
            height: 200,
            category: 'demo'
        },
        {
            src: 'https://placehold.co/300x200/0000FF/FFFFFF?text=Image+Bleue',
            title: 'Image Bleue',
            alt: 'Image de démonstration bleue',
            width: 300,
            height: 200,
            category: 'demo'
        },
        {
            src: 'https://placehold.co/400x300/FFFF00/000000?text=Image+Jaune',
            title: 'Image Jaune',
            alt: 'Image de démonstration jaune',
            width: 400,
            height: 300,
            category: 'demo'
        },
        {
            src: 'https://placehold.co/350x250/FF00FF/FFFFFF?text=Image+Magenta',
            title: 'Image Magenta',
            alt: 'Image de démonstration magenta',
            width: 350,
            height: 250,
            category: 'demo'
        }
    ]
};

// Configuration pour des images réelles - exemple avec des images libres de droits
const realImageConfig = {
    predefinedImages: [
        {
            src: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=300&fit=crop',
            title: 'Montagne au coucher du soleil',
            alt: 'Belle vue de montagne au coucher du soleil',
            width: 400,
            height: 300,
            category: 'nature'
        },
        {
            src: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400&h=300&fit=crop',
            title: 'Forêt verdoyante',
            alt: 'Sentier dans une forêt verdoyante',
            width: 400,
            height: 300,
            category: 'nature'
        },
        {
            src: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=400&h=300&fit=crop',
            title: 'Lac de montagne',
            alt: 'Lac paisible entouré de montagnes',
            width: 400,
            height: 300,
            category: 'nature'
        },
        {
            src: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=300&fit=crop',
            title: 'Plage tropicale',
            alt: 'Plage avec palmiers et eau turquoise',
            width: 400,
            height: 300,
            category: 'nature'
        },
        {
            src: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?w=400&h=300&fit=crop',
            title: 'Bureau moderne',
            alt: 'Espace de travail moderne avec ordinateur',
            width: 400,
            height: 300,
            category: 'business'
        }
    ]
};

// Configuration pour des images locales - exemple pour un projet réel
const localImageConfig = {
    predefinedImages: [
        {
            src: '/assets/images/company-logo.png',
            title: 'Logo de l\'entreprise',
            alt: 'Logo officiel de l\'entreprise',
            width: 200,
            height: 100,
            category: 'branding'
        },
        {
            src: '/assets/images/team-photo.jpg',
            title: 'Photo d\'équipe',
            alt: 'Photo de l\'équipe de développement',
            width: 500,
            height: 300,
            category: 'team'
        },
        {
            src: '/assets/images/product-showcase.jpg',
            title: 'Présentation produit',
            alt: 'Image de présentation du produit principal',
            width: 600,
            height: 400,
            category: 'product'
        }
        // Ajoutez vos propres images ici...
    ]
};

// Exportez la configuration que vous souhaitez utiliser
// Changez 'defaultImageConfig' par 'realImageConfig' ou 'localImageConfig' selon vos besoins
export default realImageConfig;

// Vous pouvez aussi créer une configuration personnalisée :
/*
const customImageConfig = {
    predefinedImages: [
        {
            src: 'votre-image-1.jpg',
            title: 'Votre titre 1',
            alt: 'Description de votre image 1',
            width: 400,
            height: 300,
            category: 'custom'
        },
        // ... ajoutez vos images ...
    ]
};

export default customImageConfig;
*/
